export default __webpack_public_path__ + "static/media/DrinkMenu.ef0f29bd.jpg";